// extracted by mini-css-extract-plugin
export default {"DescriptionList":"DescriptionList_yrKZh","DescriptionList_heading":"DescriptionList_heading_zMpSK","DescriptionList_item":"DescriptionList_item_sh4Ig"};